<template>
  <div class="container auction-live tenant-auction-live" v-if="auction && (auction.state === CONSTANTS.AUCTION_STATE_STARTED)">
    <div class="row no-margin-rl">
      <div class="col-md-12 no-padding-rl">
        <div class="auction-live-top">
          <div class="auction-live-header mg-sm-15">
            <div class="bottom">
              <div class="change-product"
                   v-bind:class="{ d_right: (previousProduct == null) }">
                <button class="btn-change" v-if="previousProduct"
                        @click="getDataBid(previousProduct); leaveChannel(auction.id, auctionProduct.order);">
                  <i class="fas fa-chevron-left icon-arrow mr-2"></i><span>前<span
                    class="d-none d-md-inline-block">の商品</span>ヘ</span>
                </button>
                <button class="btn-change" v-if="nextProduct"
                        @click="getDataBid(nextProduct); leaveChannel(auction.id, auctionProduct.order);">
                  <span>次<span class="d-none d-md-inline-block">の商品</span>ヘ</span><i
                    class="fas fa-chevron-right icon-arrow ml-2"></i>
                </button>
              </div>
              <div class="product-no">
                <div class="b-info b-tag">
                <span class="tag tag-pink tag-live" v-if="auctionProduct.is_streaming == 1"><img
                                        :src="'/img/home/icon-live.svg'" class="mr-1" alt="">LIVE</span>
                </div>
                <span class="product-text">
                                    Lot No.
                                    <span class="product-id">{{ auctionProduct.order }}</span>
                                </span>
              </div>
              <div class="auction-info">
                <div class="b-info">
                  開催日時 :
                  <span class="text">{{ formatDate(auction.start_time) }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="auction-live-content">
            <div class="left">
              <div class="video-product">
                <embed v-if="youtubeStream" style="width: 100%; height: 350px"
                       :src=urlStream>
                <video v-if="!youtubeStream" id="player" autoplay playsinline muted controls
                       @canplay="updatePaused" @playing="updatePaused" @pause="updatePaused"></video>
              </div>
            </div>
            <div class="right">
              <div class="current-price">
                <div class="b-current-price">
                  <div class="top">
                    <div class="tag-finish" v-if="isFinish">
                      販売終了
                    </div>
                    <p class="title">現在価格</p>
                    <div class="price">
                      <span class="text">¥</span>
                      <span class="number">{{ formatPrice(amountBid) }}</span>
                    </div>
                    <div class="tax-fee">
                      <span class="text">その内消費税</span>
                      <span class="number">¥{{ handlePriceTaxAndServiceFee(amountBid) }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <p class="noti-finish win" v-if="isWinBid && isFinish && !isBidFail">
                <img src="/img/frontend/award-bid-won.svg" alt="award-bid-won">
                あなたが落札者です。
              </p>
              <p class="noti-finish lose" v-if="!isWinBid && isFinish && !isBidFail">
                <img src="/img/frontend/lose-bid-sad.svg" alt="lose-bid-sad">
                他のお客様が落札しました。
              </p>
              <div class="block-noti" v-if="isChangePriceText">
                <div class="text-updated"><i class="icon fas fa-exclamation-circle"></i>
                  <span>現在の入札価格が更新されています。</span>
                </div>
              </div>
              <div class="overbid-hall mt-3">
                <div class="title-2">入札価格</div>
                <div class="starting-price mb-10">
                  <input id="amount-overbid" class="bid-amount-input" type="text" name="amount-overbid"
                          v-model="amountOverbidValue"
                          v-bind:placeholder="formatPrice(amountBid)"
                          v-bind:disabled="!isAuctionLiveAndStreaming"
                          v-bind:class="{ disable: (!isAuctionLiveAndStreaming) }"
                         @keypress="allowNumbersOnly">
                </div>
                <div class="shortcut grid-shortcut">
                  <span class="shortcut-btn" @click="updateAmountOverbidByShortcut('add', 1000)">+ ¥1,000</span>
                  <span class="shortcut-btn" @click="updateAmountOverbidByShortcut('add', 5000)">+ ¥5,000</span>
                  <span class="shortcut-btn" @click="updateAmountOverbidByShortcut('add', 10000)">+ ¥10,000</span>
                </div>
                <div id="errors-overbid-hall" style="color: #E52D51;" class="mt-2" v-if="overbidLiveError">{{ overbidLiveError }}</div>
              </div>

              <div class="block-bottom-live-bid">
                <button class="btn-send-price btn-large btn-can-bid" @click.prevent="updateAmountOverBid()"
                        v-if="isAuctionLiveAndStreaming"
                        v-bind:class="{ 'btn-disabled-tenant': (!isAuctionLiveAndStreaming && !isButtonDisabled) || isBidPause }"
                >入札する
                </button>

                <button class="btn-send-price btn-large btn-can-not-bid"
                        v-if="!isAuctionLiveAndStreaming"
                        v-bind:class="{ 'btn-disabled-tenant': (!isAuctionLiveAndStreaming && !isButtonDisabled) || isFinish || !isBidPause}"
                >入札する
                </button>
                <p class="confirm-bid">
                  <input type="checkbox" id="confirm-cbk"
                         v-model="isConfirmModalOpen"
                  >
                  <label for="confirm-cbk">※入札確認を表示しない</label>
                  <i class="icon fas fa-question-circle show-tooltip" style="cursor: pointer">
                  </i>
                </p>

                <div class="confirm-bid-tool-tip">
                  「入札する」ボタンを押した際に、確認画面が出現しなくなります。
                  <br>
                  ※「入札確認を表示しない」による誤入札にはくれぐれもご注意ください。
                </div>
              </div>
              <HistoryBidComponent :histories="histories" :member="member"
                                   :duplicateBidAmountMax="duplicateBidAmountMax"/>
            </div>
          </div>
          <div class="modal-won-bid">
            <div class="modal-overlay" v-if="isModalOpen">
              <div class="modal-1">
                <span class="close" @click="closeModal">&times;</span>
                <div class="content">
                  <div class="b-content">
                    <div class="b-img">
                      <img src="/img/frontend/harmer_won_bid.svg" alt="harmer_won_bid">
                      <img src="/img/frontend/harmer_won_bid.svg" alt="harmer_won_bid">
                      <img src="/img/frontend/harmer_won_bid.svg" alt="harmer_won_bid">
                    </div>
                    <p class="title" v-if="isWinBid && isFinish">
                      あなたが Lot No. {{ auctionProduct.order}} の落札者です。<br>
                    </p>
                    <p class="title" v-if="!isWinBid && isFinish">
                      Lot No. {{ auctionProduct.order}} の入札時間が終了しました。
                    </p>
                    <div v-if="isWinBid && isFinish">
                      <p class="price">
                        入札価格：
                        <span class="number">¥{{ formatPrice(priceBidFinish) }}</span>
                      </p>
                      <div class="text-small">
                        その内消費税：
                        <span>(¥){{ formatPrice(priceBidFinishIncludeTax) }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer border-top-0 justify-content-center">
                    <button type="button"
                            class="btn btn-close-modal"
                            data-dismiss="modal" @click="closeModal()">閉じる
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal confirm bid -->
          <div class="modal fade" id="priceBidProductModal" tabindex="-1"
               aria-labelledby="exampleModalLabel"
               aria-hidden="true" data-backdrop="static">
            <div class="modal-dialog transform-modal">
              <div class="modal-content">
                <div class="modal-header border-bottom-0">
                  <h3 class="modal-title font-weight-bold text-right"
                      style="width: 59%">
                    入札確認</h3>
                  <button type="button" class="close" data-dismiss="modal"
                          aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="text-center mt-4">
                  <span>入札価格 :</span>
                  <span class="color-red"
                        style="font-weight: 700;color: #E52D51 !important;">¥{{ formatPrice(amountBidModal) }}</span>
                </div>
                <div class="text-center mt-1">
                  <span>その内消費税</span>
                  <span>(¥{{
                      handlePriceTaxAndServiceFee(amountBidModalFormated)
                    }})</span>
                </div>
                <div class="text-center mt-1 mb-4">
                  <span>この金額で入札する</span>
                </div>
                <div class="modal-footer border-top-0 justify-content-center">
                  <button
                      @click="handleUpBidPrice('', auction.id, auctionProduct.id, priceStep)"
                      class="btn btn-submit-modal-bid-price-product">はい
                  </button>
                  <button type="button"
                          class="btn btn-cancel-modal-bid-price-product"
                          data-dismiss="modal">いいえ
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container auction-live" v-else-if="isEndBid">
    <div class="row">
      <div class="col-md-12 empty-live">
        <div class="b-text">
          <div class="title">開催終了</div>
          <div class="mb-3 bottom-title-image"></div>
          <div class="text">
            本日のLIVE配信オークションは終了致しました。<br>
            落札者にお支払い内容を連絡させていただきます。
          </div>
          <div class="btn-back d-flex justify-content-center">
            <a class="back-home" type="button" href="/home">トップページに戻る</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.btn-back {
  .back-home {
    padding: 20px 75px;
    height: 55px;
    font-weight: 400;
    line-height: 23px;
    display: flex;
    align-items: center;
  }
}
</style>
<script>
import CONSTANTS from "../../constants";
import HistoryBidComponent from './HistoryBidComponent';
import SimpleLightbox from 'simplelightbox';
import 'simplelightbox/dist/simple-lightbox.min.css';
import {COMMON} from "../../../common";

export default {
  computed: {
    isAuctionLiveAndStreaming() {
      return this.auctionProduct && this.auction
          && this.auctionProduct.is_streaming == CONSTANTS.AUCTION_IS_STREAMING_TRUE
          && this.auction.state == CONSTANTS.AUCTION_STATE_STARTED;
    },
    CONSTANTS() {
      return CONSTANTS
    },
  },
  mounted() {
    document.addEventListener('keyup', this.handleShortcutKeys);
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.handleShortcutKeys);
    if (this.auction && this.auctionProduct) {
      this.leaveChannel(this.auction.id, this.auctionProduct.order);
    }
  },
  async created() {
    await this.getDataBid();

    await this.playWowza();

    Echo.channel('auction.live')
        .listen('.auction.live', (e) => {
          this.getDataBid();
        });

    Echo.channel('auction.' + this.auction.id)
        .listen('.auction.end', (e) => {
          let btnLive = document.getElementsByClassName("btn-live");

          btnLive[0].classList.remove('d-flex');
          btnLive[0].classList.add('d-none');
          this.auction.state = e.auction.state;
          this.auction.is_streaming = e.auction.is_streaming;
          this.isChangePriceText = false;
          this.isModalOpen = false;
          this.isFinish = false;
          this.isWinBid = false;
          this.isEndBid = true;
        });

    Echo.channel('auction.' + this.auction.id)
        .listen('.auction.trackProductLive', (e) => {
          if (this.auctionProduct.order != e.auctionProduct.order) {
            this.leaveChannel(this.auction.id, this.auctionProduct.order);
            this.getDataBid(e.auctionProduct.order);
          }
        });

    Echo.channel('bid.' + this.auction.id + '.' + this.auctionProduct.order)
        .listen('.bid.start', (e) => {

          this.auctionProduct.is_streaming = e.auctionProduct.is_streaming;
          this.auctionProduct.state = e.auctionProduct.state;
          this.auctionProduct.member_id = e.auctionProduct.member_id;
          this.auctionProduct.amount = e.auctionProduct.amount;
          this.isButtonDisabled = true;
          this.isBidFail = e.auctionProduct.member_id == null;
          this.closeBidProductModal();
          if (this.auctionProduct.state == CONSTANTS.AUCTION_STATE_FINISH) {
            this.isWinBid = this.auctionProduct.member_id == this.member.id;
            this.isFinish = true;
            setTimeout(() => {
              this.isModalOpen = true;
            }, 1000);
            this.priceBidFinish = this.auctionProduct.amount;
            this.priceBidFinishIncludeTax = this.priceBidFinish / 11;

            this.idProductFinish = e.auctionProduct.order;
            this.isChangePriceText = false;
          } else if (this.auctionProduct.state == CONSTANTS.AUCTION_STATE_END && this.auctionProduct.is_streaming == 0 && e.auctionProduct.is_finished == 1) {
            setTimeout(() => {
              this.isModalOpen = true;
            }, 1000);
            this.idProductFinish = e.auctionProduct.order;
            this.isFinish = true;
            this.isChangePriceText = false;
          }
        });

    Echo.channel('bid.' + this.auction.id + '.' + this.auctionProduct.order)
        .listen('.bid.sent', (e) => {
          if (this.amountBid || this.amountBid == 0) {
            this.amountBid = e.bid.amount;
          }
          this.duplicateBidAmountMax = e.duplicateBidAmountMax ?? 0;
          this.histories.unshift(e.bid);
          this.isChangePriceText = e.member.id !== this.member.id;
          this.priceStep = e.priceStep;
        });

    Echo.channel('bid.' + this.auction.id + '.' + this.auctionProduct.order)
        .listen('.bid.pause', (e) => {
          this.isBidPause = e.auctionProduct.is_pause == CONSTANTS.IS_PAUSE_TRUE;
        })

    Echo.channel('bid.' + this.auction.id + '.' + this.auctionProduct.order)
        .listen('.bid.reset', (e) => {
          if (this.auctionProduct.order == e.auctionProduct.order) {
            this.isChangePriceText = false;
            this.isFinish = false;
            this.isWinBid = false;
            this.getDataBidNew(e.auctionProduct.order);
            this.histories = [];
            this.isModalOpen = false;
            this.isBidPause = false;
            this.closeBidProductModal();
          }
        })

    Echo.channel('bid.' + this.auction.id + '.' + this.auctionProduct.order)
        .listen('.bid.sentLiveHall', (e) => {
          if (e.bid) {
            this.isChangePriceText = true;
            if (this.amountBid || this.amountBid == 0) {
              this.amountBid = e.bid.amount;
            }
            this.histories.unshift(e.bid);
            this.priceStep = e.priceStep;
          }

          this.duplicateBidAmountMax = e.duplicateBidAmountMax ?? 0;
        });

    this.initSimpleLightbox();
  },
  data: function () {
    return {
      histories: [],
      auction: null,
      product: null,
      previousProduct: null,
      nextProduct: null,
      amountBid: null,
      amountMyBid: null,
      isButtonDisabled: false,
      member: null,
      isModalOpen: false,
      lightbox: null,
      youtubeStream: false,
      urlStream: null,
      priceBidFinish: 0,
      idProductFinish: 0,
      loading: false,
      priceStep: null,
      isConfirmModalOpen: false,
      isChangePriceText: false,
      isWinBid: false,
      isFinish: false,
      isEndBid: false,
      isBidFail: false,
      amountBidModal: null,
      duplicateBidAmountMax: 0,
      auctionProduct: null,
      amountOverbidValue: '',
      amountBidModalFormated: '',
      overbidLiveError: null,
      checkModalOpen: false,
      isBidPause: false,
      priceBidFinishIncludeTax: 0,
      mixWowzaWss: null,
      mixWowzaAppName: null,
      mixWowzaStreamName: null,
    }
  },
  methods: {
    async playWowza() {
      if (!this.youtubeStream) {
        const player = new WowzaRtc.WowzaWebRtcPlayer('player');
        player.start(
            this.mixWowzaWss,
            this.mixWowzaAppName,
            this.mixWowzaStreamName
        );
      }
    },

    updatePaused(event) {
      if (event.type === "pause") {
        this.playWowza();
      }
    },

    getAmountNextBid(amountBid) {
      return this.formatPrice(amountBid + this.priceStep);
    },

    async getDataBid(lot = null) {
      await axios.post(lot ? `/member/bid/get-tenant-data-live-bid?lot=${lot}` : '/member/bid/get-tenant-data-live-bid')
          .then(response => {
            if (response.data.auction.state !== CONSTANTS.AUCTION_STATE_STARTED || response.data.auction.is_streaming !== '1') {
              if (this.isEndBid !== true) {
                window.location.href = '/home';
              }
            }

            this.auction = response.data.auction;
            this.auctionProduct = response.data.auctionProduct;
            this.product = response.data.product;
            this.previousProduct = response.data.previousProduct;
            this.nextProduct = response.data.nextProduct;
            this.member = response.data.member;
            this.histories = response.data.histories;
            this.amountBid = response.data.amountBid;
            this.priceStep = response.data.priceStep;
            this.duplicateBidAmountMax = response.data.duplicateBidAmountMax;
            this.isBidPause = response.data.auctionProduct.is_pause == CONSTANTS.IS_PAUSE_TRUE;
            this.mixWowzaWss = response.data.mixWowzaWss;
            this.mixWowzaAppName = response.data.mixWowzaAppName;
            this.mixWowzaStreamName = response.data.mixWowzaStreamName;

            this.amountMyBid = response.data.amountMyBid
            this.isButtonDisabled = response.data.auctionProduct.is_streaming == 1 && response.data.auctionProduct.is_pause == 0;
            this.isModalOpen = false;

            if (response.data.auction.stream_url != null && response.data.auction.stream_url != '') {
              this.youtubeStream = true;
              this.urlStream = response.data.auction.stream_url + '?autoplay=1&mute=1';
            } else {
              this.youtubeStream = false;
              this.urlStream = null;
            }

            if (lot) {
              Echo.leave();

              Echo.channel('bid.' + this.auction.id + '.' + this.auctionProduct.order)
                  .listen('.bid.start', (e) => {

                    this.auctionProduct.is_streaming = e.auctionProduct.is_streaming;
                    this.auctionProduct.state = e.auctionProduct.state;
                    this.auctionProduct.member_id = e.auctionProduct.member_id;
                    this.auctionProduct.amount = e.auctionProduct.amount;
                    this.isButtonDisabled = true;
                    this.isBidFail = e.auctionProduct.member_id == null;
                    this.closeBidProductModal();
                    if (this.auctionProduct.state == CONSTANTS.AUCTION_STATE_FINISH) {
                      this.isWinBid = this.auctionProduct.member_id == this.member.id;
                      this.isFinish = true;
                      setTimeout(() => {
                        this.isModalOpen = true;
                      }, 1000);
                      this.priceBidFinish = this.auctionProduct.amount;
                      this.priceBidFinishIncludeTax = this.priceBidFinish / 11;

                      this.idProductFinish = e.auctionProduct.order;
                      this.isChangePriceText = false;
                    } else if (this.auctionProduct.state == CONSTANTS.AUCTION_STATE_END && this.auctionProduct.is_streaming == 0 && e.auctionProduct.is_finished == 1) {
                      setTimeout(() => {
                        this.isModalOpen = true;
                      }, 1000);
                      this.idProductFinish = e.auctionProduct.order;
                      this.isFinish = true;
                      this.isChangePriceText = false;
                    }
                  });

              Echo.channel('bid.' + this.auction.id + '.' + this.auctionProduct.order)
                  .listen('.bid.sent', (e) => {
                    if (this.amountBid || this.amountBid == 0) {
                      this.amountBid = e.bid.amount;
                    }
                    this.duplicateBidAmountMax = e.duplicateBidAmountMax ?? 0;
                    this.histories.unshift(e.bid);
                    this.isChangePriceText = e.member.id !== this.member.id;
                    this.priceStep = e.priceStep;
                  });

              Echo.channel('bid.' + this.auction.id + '.' + this.auctionProduct.order)
                  .listen('.bid.pause', (e) => {
                    this.isBidPause = e.auctionProduct.is_pause == CONSTANTS.IS_PAUSE_TRUE;
                  })

              Echo.channel('bid.' + this.auction.id + '.' + this.auctionProduct.order)
                  .listen('.bid.reset', (e) => {
                    if (this.auctionProduct.order == e.auctionProduct.order) {
                      this.isChangePriceText = false;
                      this.isFinish = false;
                      this.isWinBid = false;
                      this.getDataBidNew(e.auctionProduct.order);
                      this.histories = [];
                      this.isModalOpen = false;
                      this.isBidPause = false;
                      this.closeBidProductModal();
                    }
                  })

              Echo.channel('bid.' + this.auction.id + '.' + this.auctionProduct.order)
                  .listen('.bid.sentLiveHall', (e) => {
                    if (e.bid) {
                      this.isChangePriceText = true;
                      if (this.amountBid || this.amountBid == 0) {
                        this.amountBid = e.bid.amount;
                      }
                      this.histories.unshift(e.bid);
                      this.priceStep = e.priceStep;
                    }

                    this.duplicateBidAmountMax = e.duplicateBidAmountMax ?? 0;
                  });

              this.destroySimpleLightbox();

              this.initSimpleLightbox();
            }
          })
          .catch(error => {
          })
    },

    async getDataBidNew(lot) {
      await axios.post(`/member/bid/get-tenant-data-live-bid?lot=${lot}`)
          .then(response => {
            if (response.data.auction.state !== CONSTANTS.AUCTION_STATE_STARTED || response.data.auction.is_streaming !== '1') {
              if (this.isEndBid !== true) {
                window.location.href = '/home';
              }
            }

            this.auction = response.data.auction;
            this.auctionProduct = response.data.auctionProduct;
            this.product = response.data.product;
            this.previousProduct = response.data.previousProduct;
            this.nextProduct = response.data.nextProduct;
            this.member = response.data.member;
            this.histories = response.data.histories;
            this.amountBid = response.data.amountBid;
            this.priceStep = response.data.priceStep;
            this.duplicateBidAmountMax = response.data.duplicateBidAmountMax ?? 0;
            this.isBidPause = response.data.auctionProduct.is_pause == CONSTANTS.IS_PAUSE_TRUE;

            this.amountMyBid = response.data.amountMyBid
            this.isButtonDisabled = response.data.auctionProduct.is_streaming == 1 && response.data.auctionProduct.is_pause == 0;
            this.isModalOpen = false;

            if (response.data.auction.stream_url != null && response.data.auction.stream_url != '') {
              this.youtubeStream = true;
              this.urlStream = response.data.auction.stream_url + '?autoplay=1&mute=1';
            } else {
              this.youtubeStream = false;
              this.urlStream = null;
            }

            this.destroySimpleLightbox();

            this.initSimpleLightbox();
          })
          .catch(error => {
          })
    },

    formatDate(dateString) {
      if (!dateString) {
        return '';
      }

      const normalizedDateString = dateString.replace(' ', 'T');
      const date = new Date(normalizedDateString);

      if (isNaN(date)) {
        return '';
      }

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      return `${year}/${month}/${day} ${hours}:${minutes}`;
    },

    formatPrice(price) {
      return COMMON.handleFormatPrice(price);
    },

    handlePriceTaxAndServiceFee(pricePresent) {
      let price = COMMON.handleTenantPriceTax(parseFloat(pricePresent));
      return this.formatPrice(price);
    },

    async handleUpBidPrice(type = null, auction, auctionProduct, priceStep = null) {
      this.isButtonDisabled = false;
      if (!this.checkModalOpen) {
        let newAmountOverBid2 = document.getElementById('amount-overbid').value;
        this.amountBidModalFormated = newAmountOverBid2.replaceAll(",", "");
      }
      await axios({
        method: 'post',
        url: `/member/bid/${auction}/${auctionProduct}/update-tenant-price-bid`,
        data: {
          type: type,
          priceStep: COMMON.extractAndParseNumber(priceStep),
          amountBidPrice: COMMON.extractAndParseNumber(this.amountBidModalFormated),
        }
      })
          .then(response => {
            if (response.data.amountMyBid != null) {
              if (response.data.amountMyBid !== 'endLive') {
                this.amountMyBid = response.data.amountMyBid.amount;
              }
              this.closeBidProductModal();
            }
            this.disableAuctionButton();
          })
          .catch((error) => {
            if (error.response.status == 422) {
              $('.text-updated').text('入札額は数値形式で入力してください。');
              this.isChangePriceText = true;
            }
            this.closeBidProductModal();
            this.disableAuctionButton();
          });
    },

    disableAuctionButton() {
      this.isButtonDisabled = false;
      const delay = 2000;

      setTimeout(() => {
        this.isButtonDisabled = true;
      }, delay);
    },

    leaveChannel(auctionId, lot) {
      this.isFinish = false;
      this.isWinBid = false;
      this.isChangePriceText = false;
      this.isModalOpen = false;
      Echo.leave('bid.' + auctionId + '.' + lot);
    },

    empty(variable) {
      return !variable;
    },

    closeModal() {
      this.isModalOpen = false;
    },

    initSimpleLightbox() {
      this.$nextTick(() => {
        this.lightbox = new SimpleLightbox('.gallery a', {});
      });
    },

    async destroySimpleLightbox() {
      if (this.lightbox) {
        await this.lightbox.destroy();
      }
    },

    backToTop() {
      this.$nextTick(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      });
    },
    openBidProductModal() {
      this.checkModalOpen = true;
      let newAmountOverBid = document.getElementById('amount-overbid').value;
      this.amountBidModal = newAmountOverBid;
      this.amountBidModalFormated = newAmountOverBid.replaceAll(",", "");

      $('#priceBidProductModal').modal('show');
    },

    closeBidProductModal() {
      this.amountBidModal = null;
      this.checkModalOpen = false;
      $('#priceBidProductModal').modal('hide');
    },

    allowNumbersOnly(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
    },

    handleSaveBidLive() {
      if (!this.isConfirmModalOpen) {
        this.openBidProductModal();
      } else {
        this.handleUpBidPrice('', this.auction.id, this.auctionProduct.id, this.priceStep);
      }
    },

    async updateAmountOverBid() {
      if (this.isAuctionLiveAndStreaming) {
        let transformedStr = this.amountOverbidValue.replaceAll(",", "");
        this.overbidLiveError = "";
        let amountNextBid = this.amountBid;

        if (!transformedStr) {
          this.overbidLiveError = '入札価格を入力してください。';
        } else if (!this.isValidNumber(transformedStr)) {
          this.overbidLiveError = '会場入札価格には、数字のみ入力してください。';
        } else if (transformedStr < amountNextBid) {
          this.overbidLiveError = '次の入札価格以上で入力してください。';
        } else {
          await this.handleSaveBidLive();
        }

        this.amountOverbidValue = "";
        setTimeout(() => {
          this.overbidLiveError = "";
        }, 3000);
      }
    },

    updateAmountOverbidByShortcut(type, value) {
      if (!this.isAuctionLiveAndStreaming) return;
      const amountNextBid = this.amountBid;
      let currentAmount = parseInt(this.amountOverbidValue.replaceAll(',', '')) || amountNextBid;
      let newAmount = 0;

      if (type === 'add') {
        newAmount = currentAmount + value;
      }

      this.amountOverbidValue = newAmount ? newAmount.toLocaleString() : '';
    },


    handleShortcutKeys(event) {
      const keyMap = {
        'F1': () => this.updateAmountOverbidByShortcut('add', 1000),
        'F2': () => this.updateAmountOverbidByShortcut('add', 5000),
        'F3': () => this.updateAmountOverbidByShortcut('add', 10000),
      };
      if (keyMap[event.key]) {
        keyMap[event.key]();
      }
    },

    isValidNumber(value) {
      return /^-?\d+(\.\d+)?$/.test(value);
    }
  },
  components: {
    HistoryBidComponent
  }
}
</script>
